import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL + "ticket/";

export const assignEmail = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}assignemail`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API assignEmail: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAllMaster = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getallmaster`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAllMaster: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAgentFilter = async (agentId) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getagentfilter?agentid=${agentId}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAgentFilter: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}getlistticket`,
      payload,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getTicket = async (caseID, isMergedTicket) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getticket?caseid=${caseID}&ismergedticket=${
        isMergedTicket ? 1 : 0
      }`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCustomControlTicket = async (caseID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getcustomcontrolticket?caseid=${caseID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCustomControlTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHistoryTicket = async (caseID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}gethistoryticket?caseid=${caseID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHistoryTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAttachmentTicket = async (caseID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getattachmentticket?caseid=${caseID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAttachmentTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSystemParameter = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getsystemparameter?key=ticketno`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getSystemParameter: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCaseCount = async (type) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getcasecount?type=${type}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCaseCount: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const insertTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}insertticket`, payload, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API insertTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const updateTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}updateticket`, payload, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API updateTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const upload = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}upload`, payload, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API upload: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const assignTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}assignticket`, payload, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API assignTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCustomInput = async (typeID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getcustominput?typeid=${typeID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCustomInput: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getResponseTemplateList = async (channelID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getresponsetemplatelist?channelid=${channelID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getResponseTemplateList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getChannelList = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getchannellist`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getChannelList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getInboundLog = async (
  dateStart,
  dateEnd,
  filterACDDevice,
  filterAgents,
  contactName,
  phoneNo,
  skip,
  take
) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getinboundlog?datestart=${dateStart}&dateEnd=${dateEnd}&filteracddevice=${filterACDDevice}&filteragents=${filterAgents}&contactname=${contactName}&phoneno=${phoneNo}&skip=${skip}&take=${take}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getInboundLog: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getQAForm = async (clientID, scoreItemID, channelID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getqaform?clientid=${clientID}${
        scoreItemID ? `&scoreitemid=${scoreItemID}` : ``
      }&channelid=${channelID}`,

      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getQAForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const saveQAForm = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}saveqaform`, payload, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API saveQAForm: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const mergeTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(`${apiUrl}mergeticket`, payload, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API mergeTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAllAccount = async (agentId) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getallaccount?agentid=${agentId}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAllAccount: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getEmailList = async (
  isActiveChatOnly = 1,
  search = "",
  sortBy = "date",
  sortDir = "desc",
  page = 1
) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getemaillist?isactivechatonly=${isActiveChatOnly}&search=${search}&sortby=${sortBy}&sortdir=${sortDir}&page=${page}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getEmailList: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getEmailMessageByTicket = async (ticketid, page = 1) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrl}getemailmessagebyticket?ticketid=${ticketid}&page=${page}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getEmailMessageByTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getFormCSAT = async (formID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrl}getformcsat/${formID}`, config);
    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getFormCSAT: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const updateFormCSAT = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}updateformcsat`,
      payload,
      config,
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API updateFormCSAT: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const assignTicketCoordinator = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}assignticketcoordinator`,
      payload,
      config,
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API assignTicketCoordinator: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const createBulkEditTicket = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}createbulkeditticket`,
      payload,
      config,
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API createBulkEditTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const forwardEmail = async (payload) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.post(
      `${apiUrl}forwardemail`,
      payload,
      config,
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API forwardEmail: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};
